// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3c2c84e2]:export {\n  sideBarWidth: 210px;\n  appHeaderHeight: 60px;\n  interval: 16px;\n}\n.stock-advantage h4[data-v-3c2c84e2] {\n  font-size: 36px;\n  padding-bottom: 32px;\n}\n", ""]);
// Exports
module.exports = exports;
